import React from 'react';
import PropTypes from 'prop-types';

const HomeAspirationsIcon = ({ dashArray, dashOffset, opacity, showStar }) => {
  return (
    <svg
      width="192"
      height="192"
      viewBox="0 0 192 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_7014_191887)">
        <circle cx="96" cy="92" r="80" fill="white" />
        <circle
          cx="96"
          cy="92"
          r="77"
          stroke={showStar ? '#E4E5E7' : 'white'}
          strokeWidth="6"
        />
      </g>
      <circle
        className="progressBar"
        cx="96"
        cy="92"
        r="77"
        fill="transparent"
        strokeWidth="6"
        stroke="#FFC50A"
        strokeDasharray={dashArray || ''}
        strokeDashoffset={dashOffset || ''}
        strokeLinecap="butt"
      />
      <circle cx="96" cy="92" r="65" fill="#E2F7FF" />
      {showStar && <circle cx="96" cy="19" r="15" fill="#FFC50A" />}
      <path
        d="M94.064 16.621L95.4667 13.7787C95.6501 13.4071 96.18 13.4071 96.3634 13.7787L97.7661 16.621L100.902 17.0762C101.312 17.1357 101.476 17.6397 101.179 17.929L98.9103 20.1415L99.4459 23.2655C99.5159 23.674 99.0871 23.9855 98.7203 23.7925L95.9151 22.317L93.1098 23.7925C92.743 23.9855 92.3142 23.674 92.3842 23.2655L92.9198 20.1415L90.651 17.929C90.3543 17.6397 90.5181 17.1357 90.9282 17.0762L94.064 16.621Z"
        fill="white"
      />
      <g opacity={opacity}>
        <path
          d="M145.44 125.942C145.721 124.233 145.592 122.394 144.813 120.469C143.342 116.835 139.968 114.175 136.074 113.785C130.666 113.244 126.016 116.77 124.761 121.68C124.004 121.399 123.204 121.226 122.339 121.226C119.484 121.226 117.018 122.978 116.001 125.487C115.785 126.028 116.196 126.612 116.758 126.612H144.618C145.007 126.612 145.354 126.331 145.418 125.942H145.44Z"
          fill="#007E86"
        />
        <path d="M107.587 58H81.1113V95.0746H107.587V58Z" fill="#969696" />
        <path
          d="M107.587 126.59H54.6357V76.8834L81.1114 58L107.587 76.8834V126.59Z"
          fill="#003381"
        />
        <path
          d="M134.041 126.59H81.1113V76.8834L107.587 58L134.041 76.8834V126.59Z"
          fill="#0075C9"
        />
        <path
          d="M115.201 100.828H101.552V126.59H115.201V100.828Z"
          fill="#003381"
        />
        <path
          d="M116.65 78.0936C114.574 76.6011 111.675 77.0337 109.858 78.8507L108.366 80.3432L106.873 78.8507C105.078 77.0554 102.158 76.6011 100.081 78.0936C97.4423 79.9971 97.226 83.6959 99.4323 85.9022L103.023 89.4929L107.414 93.8839C107.933 94.403 108.777 94.403 109.296 93.8839L113.687 89.4929L117.277 85.9022C119.484 83.6959 119.267 79.9971 116.628 78.0936H116.65Z"
          fill="#FFC50A"
        />
        <path
          d="M73.5623 93.7344H63.1797V110.844H73.5623V93.7344Z"
          fill="#0075C9"
        />
        <path
          d="M95.95 93.7344H85.5674V110.844H95.95V93.7344Z"
          fill="#003381"
        />
        <path
          d="M130.753 93.7344H120.371V110.844H130.753V93.7344Z"
          fill="#003381"
        />
        <path
          d="M76.5041 125.942C76.7852 124.233 76.6555 122.394 75.8768 120.469C74.4059 116.835 71.0315 114.175 67.1381 113.785C61.7305 113.244 57.0799 116.77 55.8253 121.68C55.0683 121.399 54.2679 121.226 53.4027 121.226C50.5475 121.226 48.0816 122.978 47.065 125.487C46.8487 126.028 47.2597 126.612 47.8221 126.612H75.6821C76.0714 126.612 76.4175 126.331 76.4824 125.942H76.5041Z"
          fill="#00B0AC"
        />
        <path
          d="M81.1112 76.8828H51.564V80.3869H81.1112V76.8828Z"
          fill="#0075C9"
        />
        <path
          d="M51.564 76.8834L78.2343 58H107.587L81.1112 76.8834H51.564Z"
          fill="#003381"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_7014_191887"
          x="0"
          y="0"
          width="192"
          height="192"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7014_191887"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7014_191887"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_7014_191887">
          <rect
            width="98.57"
            height="68.5902"
            fill="white"
            transform="translate(47 58)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

HomeAspirationsIcon.propTypes = {
  percentage: PropTypes.string,
};

HomeAspirationsIcon.defaultProps = {
  percentage: '0%',
};

export default HomeAspirationsIcon;
